(function($) {

	$.fn.otherOption = function(options) {

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend(true, {}, options, $this.metadata()) : options;
            eOpts = $.fn.dataset ? $.extend(true, eOpts, $this.dataset()) : eOpts;

            var name = eOpts['name'].replace( /(:|\.|\[|\]|,)/g, "\\$1" );
            var value = eOpts['value'];
            var $target = $this.closest("form").find(':input[name='+name+']');
            var $dropdownlist = $target.closest('.jqx-widget.dropdownlist');
            $dropdownlist.on('select checkChange',checkChange);
            checkChange();
            function checkChange() {
                var isOther = false;
                if($dropdownlist.jqxDropDownList('checkboxes')) {
                    var item = $dropdownlist.jqxDropDownList('getItemByValue', value);
                    isOther = item.checked;
                }
                else {
                    var selectedItem = $dropdownlist.jqxDropDownList('getSelectedItem');
                    isOther = selectedItem.value == value;
                }
                if(isOther) {
                    $this.show();
                }
                else {
                    $this.hide();
                }
            }
        });
	};

})(jQuery);